import React from 'react';

import ShipmentFiltersPanelView from './ShipmentFiltersPanelView';
import {
  ExtendedShipmentsFilterPanelProps,
  useShipmentFiltersPanelController,
} from '../hooks/useShipmentFiltersPanelController';

const ShipmentsFilterPanel: React.FC<ExtendedShipmentsFilterPanelProps> = (
  props
) => {
  const controller = useShipmentFiltersPanelController(props);

  return <ShipmentFiltersPanelView {...controller} />;
};

export default ShipmentsFilterPanel;
